import {getLayerSourceParams} from "@/helpers/ol/ol-layer-helper";

export function getPrintLayerWms(layer) {

    let serviceUrl = layer.Url

    if(layer.Service.PrintDirectly === 1) {
        serviceUrl = layer.Service.PrintUrl
    }

    try {
        new URL(serviceUrl);
    } catch (_) {
        serviceUrl = window.kaartViewerUrl + serviceUrl
    }

    const filter = getLayerSourceParams(layer.id)

    // console.log(filter)

    let printLayer = {}
    printLayer.baseURL = serviceUrl

    if(layer.Untiled === 0) {
        printLayer.type = 'TILEDWMS'
    } else {
        printLayer.type = 'WMS'
    }

    printLayer.opacity = layer.Opacity / 10
    printLayer.singleTile = true
    printLayer.layers = [layer.Layer]
    printLayer.format = 'image/png'
    printLayer.imageFormat = 'image/png'
    printLayer.version = '1.3.0'
    printLayer.styles = [""]
    printLayer.customParams = {
        "TRANSPARENT": true
    }

    if(filter.FILTER) {
        printLayer.customParams.FILTER = filter.FILTER
    }
    if(filter.CQL_FILTER) {
        printLayer.customParams.CQL_FILTER = filter.CQL_FILTER
    }

    printLayer.sorting = layer.zIndex

    return printLayer
}
